const numberFormat = new Intl.NumberFormat('en-US')

function NumberFormatted({ value }) {
  return numberFormat.format(value)
}

export default NumberFormatted
